/* unplugin-vue-components disabled */import script from "./RecordUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./RecordUpdate.vue?vue&type=style&index=0&id=37055ab8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37055ab8"]])

export default __exports__